import { AsyncPipe, NgIf, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { DossierStateHistory } from '@sc/data-access-models';
import { LocaleDatePipe } from '@sc/data-access-translation';
import { IconComponent, MomentParseZonePipe } from '@sc/ui-components';

@Component({
  selector: 'sc-declaration-end-history-date',
  styleUrls: ['./declaration-end-history-date.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    IconComponent,
    AsyncPipe,
    TitleCasePipe,
    MomentParseZonePipe,
    LocaleDatePipe,
  ],
  template: `
    <div *ngIf="state?.timestamp">
      <div class="icon">
        <sc-icon [name]="icon"></sc-icon>
      </div>
      <span
        >{{
          state.timestamp
            | parseZoneTimeString: 'Europe/Paris'
            | localeDate: 'fullDate'
            | async
            | titlecase
        }}
        ,
        {{
          state.timestamp
            | parseZoneTimeString: 'Europe/Paris'
            | localeDate: 'shortTime'
            | async
        }}
      </span>
    </div>
  `,
})
export class DeclarationEndHistoryDateComponent {
  @Input() state: DossierStateHistory;
  @Input() icon: IconName = 'book_appointment';
}
